module.exports = __webpack_public_path__ + "media/images/matrix-logo-c643d28ce7aedd00959210c64e800562.png";